<footer class="footer eye-color">
  @if (hasCachedStatic() || staticRequestState().success) {
    <div class="footer__item footer__item--gradient eye-border-color">
      <div class="container">
        <div class="footer__logos">
          <img
            class="footer__logo eye-d-none"
            src="../assets/img/logos/logo-dark_{{ lang }}.png"
            srcset="../assets/img/logos/logo-dark_{{ lang }}@2x.png 2x, ../assets/img/logos/logo-dark_{{ lang }}@3x.png 3x"
            alt="{{ 'LOGO_COMPANY' | translate }}"
          />
          <a href="tel:154" class="footer__tel eye-hover">
            <div
              [inlineSVG]="'../assets/img/misc/tel-154.svg'"
              aria-label="154"
            ></div>
          </a>
        </div>
        <app-footer-nav />
        <app-footer-gov />
      </div>
    </div>
    <div class="footer__item eye-border-color">
      <div class="container">
        <app-footer-contacts />
      </div>
    </div>
    <div class="footer__item eye-border-color">
      <div class="container">
        <app-footer-social />
      </div>
    </div>
    <div class="footer__item eye-border-color eye-d-none">
      <div class="container footer__payment-systems">
        <app-footer-payment-system />
      </div>
    </div>
    <div class="footer__item eye-border-color eye-d-none">
      <div class="container">
        <app-footer-copyright />
      </div>
    </div>
  } @else if (staticRequestState().loading) {
    <app-footer-loading />
  } @else if (staticRequestState().error) {
    <div class="footer__error-container container">
      <app-content-unavailable (reload)="reload()" />
    </div>
  }
</footer>
